import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=2b9acd10&scoped=true"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9acd10",
  null
  
)

export default component.exports